<template>
  <div class="vx-row">
    <div class="vx-col w-full md:w-1/3 mb-base" v-show="$auth.checkRoles(gcRoles.samplesOrCollaborators)">
      <vx-card  slot="no-body" :title="$t('Edit')" class="text-center greet-user mb-5" v-show="$auth.checkRoles(gcRoles.collaborators)">
        <menu-control :items="editItems">
        </menu-control>
        <div  v-show="$auth.checkRoles(gcRoles.readers) && $auth.checkRoles( [ 'MeliadineUsers'] )">
          <h5 class="text-left mb-3">{{ this.$t('GradeControl.MLViews.Importation')}}</h5>
          <ul class="menu_line">
            <li>
              <div class="menu-icon bg-secondary">
                <feather-icon icon="UploadIcon" svgClasses="text-white stroke-current w-5 h-5" />
              </div>
              <div class="menu-text">
                <a class="text-primary" href="#" @click.prevent="confirmImportMLViews()">{{ $t('Export')}}</a>
              </div>
            </li>
          </ul>
        </div>
      </vx-card>
      <admin-menu/>
    </div>
    <div class="vx-col md:w-2/3 w-full mb-base">
      <reports-menu/>
    </div>
  </div>
</template>

<script>
import AdminMenu from './components/AdminMenu.vue'
import ReportsMenu from './components/ReportsMenu.vue'
import gcRoles from './roles.js'
import menuControl from '@/app/shared/components/lists/menu.vue'

export default {
  components: {
    AdminMenu,
    ReportsMenu,
    menuControl
  },
  data() {
    return {
      gcRoles,
      editItems : [ 
        {
          roles : gcRoles.collaborators,
          icon : "ClockIcon",
          to : "/geo/gradecontrol/timesheet",
          i18nTitle : "GradeControl.Timesheet.Title"
        },
        {
          roles : gcRoles.samples,
          faIcon : "vial",
          to : "/geo/gradecontrol/samples",
          i18nTitle : "GradeControl.Sample.LIMSTitle"
        },
        {
          roles : gcRoles.collaborators,
          icon : "TargetIcon",
          to : "/geo/gradecontrol/forecast",
          i18nTitle : "GradeControl.Forecast.Title"
        },
        {
          roles : gcRoles.collaborators,
          faIcon : "balance-scale",
          to : "/geo/gradecontrol/posting",
          i18nTitle : "GradeControl.Posting.Title"
        },
        {
          roles : gcRoles.collaborators,
          icon : "FilterIcon",
          to : "/geo/gradecontrol/nsr",
          i18nTitle : "GradeControl.NSRForecast.Title"
        }
      ]
    }
  },
  methods : {
    confirmImportMLViews() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: this.$t("Import"),
        text: this.$t('GradeControl.MLViews.ConfirmImport'),
        accept: this.importMLViews
      });
    },
     
    importMLViews() {
      this.$vs.notify({
        title: this.$t("Import"),
        text: this.$t("GradeControl.MLViews.InProgress"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });
      this.$webApi.post('geo/gradecontrol/MLViews/').then(() => {
        this.$vs.notify({
          title: this.$t("Success"),
          text: this.$t("GradeControl.MLViews.Success"),
          color: "success",
          iconPack: 'feather',
          icon:'icon-check',
          fixed:true
        });
      }).catch((error) => {
        this.$vs.notify({
          color: "danger",
          title: this.$t("LoadingError"),
          text: error.message  
        })
      });
    }
  }
};
</script>